function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { isObject } from "../is/index";
export function curry(targetFn) {
    for(var _len1 = arguments.length, existingArgs = new Array(_len1 > 1 ? _len1 - 1 : 0), _key1 = 1; _key1 < _len1; _key1++){
        existingArgs[_key1 - 1] = arguments[_key1];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var totalArgs = _toConsumableArray(existingArgs).concat(_toConsumableArray(args));
        if (totalArgs.length >= targetFn.length) {
            return targetFn.apply(void 0, _toConsumableArray(totalArgs));
        }
        return curry.apply(void 0, [
            targetFn
        ].concat(_toConsumableArray(totalArgs)));
    };
}
export function compose() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
        fns[_key2] = arguments[_key2];
    }
    var reduceComposedFns = function(prevFn, nextFn) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return prevFn(nextFn.apply(void 0, _toConsumableArray(args)));
        };
    };
    return fns.reduce(reduceComposedFns);
}
export var isEmpty = function(value) {
    if (isObject(value)) {
        if (Array.isArray(value)) {
            return value.length ? value : undefined;
        }
        return Object.keys(value).length ? value : undefined;
    }
    return value;
};
export var reduce = curry(function(fn, initial, array) {
    return array.reduce(fn, initial);
});
export var propOr = function(key, fallback, obj) {
    return obj[key] || fallback;
};
export var split = curry(function(pattern, string) {
    return string.split(pattern);
});
export var dig = curry(function(keys, props) {
    var splitDot = split('.');
    var reduceMappedProps = reduce(function(acc, key) {
        return propOr(key, {}, acc);
    }, props);
    return compose(isEmpty, reduceMappedProps, splitDot)(keys);
});
